import { useContext, useEffect, useState } from "react";
import "../../../css/wallet/History/History.css";
import { useTranslation } from "react-i18next";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../SessionChecker/SessionChecker";
import Statistics from "./Statistics/Statistics";
import HistoryLoading from "./HistoryLoading1";

function History({ theme }) {

  const { t } = useTranslation();

  const navigate = useNavigate();

  const { sessionStatus } = useContext(AuthContext);

  const location = useLocation();

  useEffect(() => {

  }, []);

  const [statisticsStatus, setStatisticsStatus] = useState(false);

  return (
    <div className="mainDiv">
      <div className={`headerDiv ${theme}`}>
        <div>{t("History")}</div>

        {sessionStatus && (
          <button
            className="iconButton"
            onClick={() => {
              setStatisticsStatus(true);
            }}
          >
            <img src="/icons/statistics.png"></img>
          </button>
        )}

        {statisticsStatus && (
          <Statistics
            theme={theme}
            setStatisticsStatus={setStatisticsStatus}
            data={[]}
          ></Statistics>
        )}
      </div>

      <div className={`contentDiv noScroll ${theme}`}>
        {sessionStatus ? (
          <>
            <div className={`tabsDiv ${theme}`}>
              <button
                className={`tabButton ${location.pathname == "/history/deposits" && "active"}`}
                onClick={() => {
                  navigate("/history/deposits");
                }}
              >
                {t("Deposits")}
              </button>
              <button
                className={`tabButton ${location.pathname == "/history/withdrawals" && "active"}`}
                onClick={() => {
                  navigate("/history/withdrawals");
                }}
              >
                {t("Withdrawals")}
              </button>
              <button
                className={`tabButton ${location.pathname == "/history/purchases" && "active"}`}
                onClick={() => {
                  navigate("/history/purchases");
                }}
              >
                {t("Purchases")}
              </button>
              <button
                className={`tabButton ${location.pathname == "/history/sales" && "active"}`}
                onClick={() => {
                  navigate("/history/sales");
                }}
              >
                {t("Sales")}
              </button>
            </div>

            <div className="historyContentDiv">
              <Outlet />
            </div>
          </>
        ) : (
          <div
            className="signinDivfromHistory"
            onClick={() => {
              navigate("/signin");
            }}
          >
            {t("Signin to view your history")}
          </div>
        )}
      </div>
    </div>
  );
}

export default History;
